import { useEffect } from 'react';
import { CLIENT_APP } from '../../constants/clientApp';

// Tags the chat session so Zendesk tickets show which app the visitor was on.
const tagClientApp = () =>
  window.zE?.('webWidget', 'chat:addTags', [`client-app-${CLIENT_APP}`]);

export const useZendesk = () => {
  useEffect(() => {
    const zendeskKey = process.env.REACT_APP_ZENDESK_KEY;
    const importScript = document.createElement('script');
    importScript.id = 'ze-snippet';
    importScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    importScript.onload = tagClientApp;
    document.body.appendChild(importScript);

    return () => {
      const scriptElement = document.getElementById('ze-snippet');
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, [process.env.REACT_APP_ZENDESK_KEY]);

  return null;
};
